const utils = require('../../../lib/utils')

module.exports = {
	model: {
		dataJSON: {},
		type: null,
		value: null,
		config: {
			defaultType: 'noChange',
			fields: {
				noChange: {
					nameKey: 'form.fields.passwordGenerator.fields.noChange.name',
					placeholderKey: 'form.fields.passwordGenerator.fields.noChange.placeholder',
					toggleIcon: 'fi fi-no-change',
				},
				generatePasswordOfLength: {
					nameKey: 'form.fields.passwordGenerator.fields.generatePasswordOfLength.name',
					placeholderKey: 'form.fields.passwordGenerator.fields.generatePasswordOfLength.placeholder',
					toggleIcon: 'fi fi-refresh',
					icon: 'fi fi-generatePasswordOfLength',
					style: 'oneLine',
					min: 8,
				},
				password: {
					nameKey: 'form.fields.passwordGenerator.fields.password.name',
					placeholderKey: 'form.fields.passwordGenerator.fields.password.placeholder',
					toggleIcon: 'fi fi-password-input',
				},
			}
		}
	},

	events: {
		/**
		 * this event handler is used to move all simple fields' values into the form model and set the dirty flag if necessary.
		 * all complex fields (field components) has to prevent the change event propagation of their simple fields and have to call the fieldToModel method of their parent form.
		 *
		 * @param event
		 */
		change: {
			type: 'change',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();
				var target = event.originalEvent ? event.originalEvent.target : event.target;
				var fieldCode = target.dataset.fieldCode;
				var fieldType = target.dataset.fieldType;

				var value = utils.dom.getHtmlFieldValue(fieldType, target);

				// set model values according to the given fieldCode and its value
				if(fieldCode !== undefined){
					event.data.component.update({
						fieldCode,
						value
					})
				}
			}
		},
	},

	methods: {
		onBuild: function(){
			this.prepareConfigs();
		},

		prepareConfigs: function(){
			const fieldConfig = this.model.config || {};
			const toggleModel = this.model.toggleModel = {
				dataTEXT: '',
				fieldCode: 'type',
				atom: {
					dataType: 'text'
				},
				aliases: {},
				'text-data': [],
			}

			var selectedConfigKey = ''
			for(var configKey in fieldConfig.fields){
				selectedConfigKey = selectedConfigKey || configKey;

				const elementConfig = fieldConfig.fields[configKey] || {}

				if(elementConfig.disabled){
					continue
				}

				if(elementConfig.toggleIcon){
					toggleModel.aliases[configKey] = {
						name: elementConfig.toggleIcon,
						type: 'symbol'
					}
				}
				if(configKey === fieldConfig.defaultType){
					selectedConfigKey = configKey;
				}

				var name = ''
				if(elementConfig.nameKey){
					name = storage.__(elementConfig.nameKey)
				}
				toggleModel['text-data'].push({
					name,
					value: configKey,
				})
			}

			this.model.dataJSON = this.model.dataJSON || {}
			this.model.type =
			this.model.dataJSON.type =
			toggleModel.dataTEXT =
				this.model.dataJSON.type || selectedConfigKey
			;
		},

		onChange: function(type, value){
			let changeFound = false
			if(!this.model.value) this.model.value = {};

			if(type !== undefined && this.model.type !== type && value === undefined){
				this.model.type = type;
				this.model.toggleModel.dataTEXT = type;
				changeFound = true;

				this.toggleTypeGUI(type)
			}
			if(value !== undefined && this.model.value[type] !== value){
				this.model.value[type] = value
				changeFound = true;
			}

			if(changeFound){
				let outerValue = null;
				if(this.model.type !== 'noChange'){
					outerValue = {
						[this.model.type]: this.model.value[this.model.type]
					}
				}

				this.parent(parentComponent => {
					parentComponent.trigger('onChildChanged', {
						fieldCode: this.model.fieldCode,
						value: outerValue
					})
				})
			}
		},

		toggleTypeGUI(type){
			const $container = this.$
			if($container && $container.length > 0){
				$container.find(`.element`).removeClass('active')
				$container.find(`.element[data-type="${type}"]`).addClass('active')
			}
		},

		update(options){
			if(options.fieldCode === 'type'){
				this.onChange(options.value, undefined);
			} else {
				this.onChange(options.fieldCode, options.value);
			}
		}
	},

	hooks: {
		onChildChanged: function($element, options){
			this.update(options)
		}
	}
};
